module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 8rem 0"
    }
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-divider', [_vm._v("房间信息")]), _vm._v(" "), _vm._l((_vm.row.room_list), function(room, index) {
    return (room.edit == false) ? _c('van-cell-group', {
      key: index
    }, [_c('van-cell', {
      attrs: {
        "input-align": "right",
        "title": room.name,
        "border": false
      },
      scopedSlots: _vm._u([{
        key: "right-icon",
        fn: function() {
          return [_c('span', {
            staticStyle: {
              "color": "#FF4768"
            }
          }, [_vm._v("¥212")]), _vm._v("  \n                    "), _c('van-icon', {
            staticStyle: {
              "line-height": "inherit"
            },
            attrs: {
              "name": "clear",
              "color": "#999"
            },
            on: {
              "click": function($event) {
                return _vm.roomRemove(index)
              }
            }
          })]
        },
        proxy: true
      }], null, true)
    }), _vm._v(" "), _c('div', {
      staticClass: "operate-desc-left"
    }, _vm._l((room.member), function(member) {
      return _c('span', [_vm._v(_vm._s(member.name) + "(" + _vm._s(_vm._f("sexName")(member.sex)) + ") " + _vm._s(_vm._f("typeName")(member.type)))])
    }), 0)], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.row.room_list), function(room, index) {
    return (room.edit == true) ? _c('van-cell-group', {
      key: index
    }, [(room.name) ? _c('van-field', {
      attrs: {
        "readonly": "",
        "clickable": "",
        "right-icon": "arrow",
        "input-align": "right",
        "label": "房型",
        "value": room.name + ' ' + room.price + '元 限住' + room.limit + '人'
      },
      on: {
        "click": function($event) {
          _vm.showRoomTypePicker = true
        }
      }
    }) : _c('van-field', {
      attrs: {
        "readonly": "",
        "clickable": "",
        "right-icon": "arrow",
        "input-align": "right",
        "label": "房型",
        "placeholder": "请先选择房型？"
      },
      on: {
        "click": function($event) {
          _vm.showRoomTypePicker = true
        }
      }
    }), _vm._v(" "), _c('van-popup', {
      attrs: {
        "position": "bottom"
      },
      model: {
        value: (_vm.showRoomTypePicker),
        callback: function($$v) {
          _vm.showRoomTypePicker = $$v
        },
        expression: "showRoomTypePicker"
      }
    }, [_c('van-picker', {
      attrs: {
        "columns": _vm.row.room_type,
        "show-toolbar": "",
        "value-key": "name",
        "default-index": 0
      },
      on: {
        "cancel": function($event) {
          _vm.showRoomTypePicker = false
        },
        "confirm": _vm.onRoomTypeConfirm
      }
    })], 1), _vm._v(" "), _c('van-field', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (room.name),
        expression: "room.name"
      }],
      attrs: {
        "readonly": "",
        "clickable": "",
        "right-icon": "arrow",
        "input-align": "right",
        "label": "入住人",
        "placeholder": "请选择人员"
      },
      on: {
        "click": function($event) {
          _vm.showMemberPicker = true
        }
      }
    }), _vm._v(" "), _c('SaiRoomMemberPicker', {
      attrs: {
        "show": _vm.showMemberPicker,
        "limit": _vm.memberLimit,
        "options": _vm.memberOptions,
        "defaultValue": room.member
      },
      on: {
        "onChange": _vm.onMemberChange,
        "onClose": function($event) {
          _vm.showMemberPicker = false
        },
        "onConfirm": _vm.onMemberConfirm
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (room.member.length > 0),
        expression: "room.member.length>0"
      }],
      staticClass: "memberResultWrap"
    }, _vm._l((room.member), function(user, index) {
      return _c('div', {
        staticClass: "memberLi"
      }, [_vm._v("\n                    入住人" + _vm._s(index + 1) + "\n                    "), _c('van-tag', {
        key: index,
        attrs: {
          "round": "",
          "color": "#fff",
          "text-color": "#666",
          "size": "large",
          "closeable": "",
          "type": "primary"
        },
        on: {
          "close": function($event) {
            return room.member.splice(index, 1)
          }
        }
      }, [_vm._v(" " + _vm._s(user.name) + " " + _vm._s(_vm._f("sexName")(user.sex)) + " " + _vm._s(_vm._f("typeName")(user.type)) + "\n                    ")])], 1)
    }), 0)], 1) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [((_vm.row.room_list.length == 0 || !_vm.row.room_list[_vm.row.room_list.length - 1].edit) && _vm.memberOptions.length > 0) ? _c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "size": "normal",
      "round": "",
      "native-type": "button"
    },
    on: {
      "click": _vm.roomAdd
    }
  }, [_vm._v("新增房间")]) : _vm._e(), _vm._v(" "), (_vm.row.room_list.length > 0 && _vm.row.room_list[_vm.row.room_list.length - 1].edit) ? _c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "size": "normal",
      "round": "",
      "native-type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.roomRemove(_vm.row.room_list.length - 1)
      }
    }
  }, [_vm._v("删除")]) : _vm._e(), _vm._v(" "), (_vm.row.room_list.length > 0 && _vm.row.room_list[_vm.row.room_list.length - 1].edit) ? _c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "size": "normal",
      "round": "",
      "native-type": "button"
    },
    on: {
      "click": _vm.roomSave
    }
  }, [_vm._v("保存")]) : _vm._e()], 1), _vm._v(" "), _c('van-divider', [_vm._v("确认信息")]), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "普通双人房",
      "value": "1"
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "普通单人房",
      "value": "1"
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "食宿费用",
      "value": "1"
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "人数",
      "value": "1"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "input-align": "right",
      "label": "备注",
      "rows": "2",
      "autosize": "",
      "type": "textarea",
      "placeholder": "您的食宿特殊要求？"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "保存中...",
      "native-type": "submit"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("暂存信息")]), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交申请")])], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34f9769a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/sai/SaiApplyFormStep4.vue
// module id = 1443
// module chunks = 0